#import "../fragments/peep-related-lead-fragment.graphql"
#import "../fragments/peep-related-lead-stats-fragment.graphql"

query GetAccountChildLeads($accountId: ID!) {
    account(id: $accountId) {
        id
        childLeads(first: 1000) {
            totalCount
            edges {
                node {
                    ...PeepRelatedLeadFragment
                }
            }
            subsidiaryStats {
                ...PeepRelatedLeadStatsFragment
            }
        }
        childAccounts(first: 1000) {
            edges {
                node {
                    id
                }
            }
        }
    }
}
